import { Platform } from '@ionic/angular';
import { Component } from '@angular/core';
import { IonApp, IonRouterOutlet } from '@ionic/angular/standalone';
import { SafeArea } from 'capacitor-plugin-safe-area';
import { ScreenOrientation } from '@capacitor/screen-orientation';
import { GlobalSpinnerComponent } from "./components/spinner-component/global-spinner-component";
import { Router } from '@angular/router';
import { AppLogger } from '../utilities/logs/app-logger';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  imports: [IonApp, IonRouterOutlet, GlobalSpinnerComponent],
})
export class AppComponent {
  constructor(private platform: Platform, private router: Router) {
    // SOP26_00111: registro de lo que pasa en la APP, se consulta en Grafana
    AppLogger.start(this.router);
    this.platform.ready().then(() => {
      if (this.platform.is('capacitor')) {
        ScreenOrientation.lock({ orientation: 'portrait' })
          .then(() => console.log('Orientation locked to portrait'))
          .catch(err => console.log('Error locking orientation', err));
      }
    });
    this.initializeApp();
  }

  async initializeApp() {
    await this.platform.ready();

    // Obtener los insets actuales
    const { insets } = await SafeArea.getSafeAreaInsets();
    this.setSafeAreaInsets(insets);

    // Obtener la altura de la status bar (opcional)
    const { statusBarHeight } = await SafeArea.getStatusBarHeight();
    console.log('StatusBarHeight:', statusBarHeight);

    // Escuchar cambios en el safe area
    await SafeArea.addListener('safeAreaChanged', ({ insets }) => {
      this.setSafeAreaInsets(insets);
    });
  }

  private setSafeAreaInsets(insets: { top: number; bottom: number; left: number; right: number }) {
    for (const [key, value] of Object.entries(insets)) {
      document.documentElement.style.setProperty(`--safe-area-inset-${key}`, `${value}px`);
    }
  }
}

